/*
  Animiertes Auf- und Zuklappen der Redesign-Akkordeons (<details>).
  - Höhe wird per Web Animations API animiert, "open" erst nach dem Zuklappen entfernt
  - Während des Zuklappens trägt das Element .is-closing (CSS zeigt dann den geschlossenen Zustand)
  - Exklusive Gruppen (name-Attribut) werden per JS gesteuert, damit auch das andere Element animiert schließt
  - prefers-reduced-motion: ohne Animation
*/
(function () {
  var SELECTOR = 'details';
  var DURATION = 380;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function stop(el) {
    if (el._dsAnim) {
      var anim = el._dsAnim;
      el._dsAnim = null;
      anim.cancel();
    }
    el.style.overflow = '';
  }

  function animateHeight(el, from, to, done) {
    if (reducedMotion.matches || typeof el.animate !== 'function' || from === to) {
      if (done) done();
      return;
    }
    el.style.overflow = 'hidden';
    var anim = el.animate({ height: [from + 'px', to + 'px'] }, { duration: DURATION, easing: EASING });
    el._dsAnim = anim;
    anim.onfinish = function () {
      if (el._dsAnim !== anim) return;
      el._dsAnim = null;
      el.style.overflow = '';
      if (done) done();
    };
  }

  function open(el) {
    var from = el.offsetHeight;
    stop(el);
    el.classList.remove('is-closing');
    el.open = true;
    animateHeight(el, from, el.offsetHeight);
  }

  function close(el) {
    var from = el.offsetHeight;
    stop(el);
    el.classList.add('is-closing');
    el.open = false;
    var to = el.offsetHeight;
    el.open = true;
    animateHeight(el, from, to, function () {
      el.open = false;
      el.classList.remove('is-closing');
    });
  }

  // name-Attribut in data-ds-name verschieben, sonst schließt der Browser die anderen sofort
  function groupOf(el) {
    var name = el.getAttribute('name');
    if (name) {
      document.querySelectorAll('details[name="' + CSS.escape(name) + '"]').forEach(function (item) {
        item.removeAttribute('name');
        item.setAttribute('data-ds-name', name);
      });
    } else {
      name = el.getAttribute('data-ds-name');
    }
    if (!name) return [];
    return Array.prototype.filter.call(
      document.querySelectorAll('details[data-ds-name="' + CSS.escape(name) + '"]'),
      function (item) { return item !== el; }
    );
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || !event.target.closest) return;
    var summary = event.target.closest('summary');
    if (!summary) return;
    if (event.target.closest('a, button, input, select, textarea, [contenteditable="true"]')) return;
    var el = summary.parentElement;
    if (!el || !el.matches(SELECTOR) || summary !== el.querySelector(':scope > summary')) return;

    event.preventDefault();
    if (el.open && !el.classList.contains('is-closing')) {
      close(el);
    } else {
      groupOf(el).forEach(function (item) {
        if (item.open && !item.classList.contains('is-closing')) close(item);
      });
      open(el);
    }
  });
})();
